import { Container, Row, Toast, Button } from 'react-bootstrap'

import ListLoader from '@atk/components/loaders/ListLoader/ListLoader'

export default function HotspotContactForm({
    loading,
    show,
    toggleShow,
}: {
    loading: boolean
    show: boolean
    toggleShow: () => void
}) {
    return (
        <Container>
            <Row>
                {loading && <ListLoader />}
                <div id="hubspotForm"> </div>
                <Toast show={show}>
                    <Toast.Body>
                        <p>Thank you! We will be in touch with you soon!</p>
                        <Button variant="secondary" onClick={toggleShow}>
                            Accept
                        </Button>
                    </Toast.Body>
                </Toast>
            </Row>
        </Container>
    )
}
